import React from 'react'
import Api from '../../Api'
// import { GetMethods, SetMethodsActive } from '$Deposits/store/actions/DepositAction'
import LB from './LB'
import EZP from './EZP'
import TMW from './TMW'
import CC from './CC'
import THBQR from './THBQR'
import BC from './BC'
import BQR from './BQR'
import LINE from './LINE'
import CTC from './CTC'
import RD from './RD'

import Components from '$Deposits/Components'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { connect } from "react-redux";
import { setDepositTriggerFrom } from '$Deposits/store/actions/DepositAction'
import { AiOutlineClose } from "react-icons/ai";

class Deposit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const {setDepositTriggerFrom,triggerFor,vendor} = this.props;
        setDepositTriggerFrom({from:triggerFor, vendor})
    }
    componentWillUnmount() {

    }

    render() {
        const { BackClick, getDepositBanner } = GetParamsData()


        return (
            <div className='DepositCenter'>
                {/*<DepositHeader leftClick={BackClick} title={'ฝากเงิน'} />*/}
                <div className='methods'>
                    <Components
                        Banner={(propCon) => {
                            return (
                                <>
                                    {
                                        propCon.bannerShow &&
                                        <div className='depositBannerBox'>
                                            {getDepositBanner && getDepositBanner(propCon.onClose)}
                                        </div>
                                    }
                                </>
                            )
                        }}

                        MethodsView={(propCon) => {
                            return (
                                <div className='methodsList'>
                                    {
                                        propCon.paymentMethods.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => { propCon.onChange(item) }}
                                                    className={`methodsItem  ${(propCon.activeCode == item.code ? 'methodsItemActive ' : ' ')}`}
                                                >
                                                    <div className='innerBox'>
                                                        {item.code === "CTC" && <div className='walletNewLabel'>New</div>}
                                                        <div className={item.code + '-icon ' + (propCon.activeCode == item.code ? (item.code + '-active-icon') : '')} />
                                                        <span>{item.name}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        propCon.paymentMethods.length == 0 &&
                                        <>
                                            {
                                                new Array(15).fill(1).map((item, index) => {
                                                    return (
                                                        <div key={index} className='methodsItemLoading' />
                                                    )
                                                })
                                            }
                                        </>
                                    }
                                </div>
                            )
                        }}
                        MethodsCode={(propCon) => {
                            const { activeCode } = propCon
                            return (<>
                                {
                                    !activeCode &&
                                    <div className='methodsCodeLoading'>
                                        {
                                            new Array(3).fill(1).map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <div className='methodsCodeTitle' />
                                                        <div className='methodsCodeItem' />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                {activeCode == 'LB' && <LB />}
                                {activeCode == 'THBQR' && <THBQR />}
                                {activeCode == 'CC' && <CC />}
                                {activeCode == 'BQR' && <BQR />}
                                {activeCode == 'EZP' && <EZP />}
                                {activeCode == 'LINE' && <LINE />}
                                {activeCode == 'BC' && <BC />}
                                {activeCode == 'TMW' && <TMW />}
                                {activeCode == 'CTC' && <CTC />}
                                {activeCode == 'RD' && <RD />}
                            </>)
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = () =>{}

const mapDispatchToProps = {
    setDepositTriggerFrom: (data)=>setDepositTriggerFrom(data)
};

export default connect(mapStateToProps, mapDispatchToProps)(Deposit)

export class DepositHeader extends React.Component {
    render() {
        const { title, closeBtn, visibleBtn = false } = this.props;
        return (
            <div className="modal-header">
                <p className="headerTitle">{title || "ขั้นตอนการฝากเงิน"}</p>
                {visibleBtn ? (
                    <div onClick={closeBtn}>
                        <AiOutlineClose />
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}


